import { func, number, oneOfType, string } from 'prop-types';
import React from 'react';

import ButtonWithMessagePopover from '../../../../generic/ButtonWithMessagePopover';
import { COLORS } from '../../../../utils/constants';
import { preventNewLines } from '../../../../utils/prevent-keyboard-actions';
import { allStatusesEnum as invoiceStatuses } from '../../../constants';

export default function RejectButton({ id, onUpdateStatus, text, ...rest }) {
  return (
    <ButtonWithMessagePopover
      outline
      id={id}
      color={COLORS.DANGER}
      title={text}
      onSubmit={message =>
        onUpdateStatus(id, invoiceStatuses.CHANGES_REQUESTED.value, message)
      } // eslint-disable-line react/jsx-curly-newline
      type="button"
      inputProps={{
        placeholder: 'Which changes are requested',
        onKeyDown: preventNewLines,
      }}
      submitProps={{
        color: COLORS.DANGER,
        children: 'Send',
      }}
      {...rest}
    >
      {text}
    </ButtonWithMessagePopover>
  );
}

RejectButton.propTypes = {
  onUpdateStatus: func.isRequired,
  id: oneOfType([number, string]).isRequired,
  text: string,
};

RejectButton.defaultProps = {
  text: 'Request Changes',
};
